// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3jzEZ","footer":"ModalUpdate_footer__EGGRw"};